/**
 * Shared component for general list and forms.
 */
export class BaseComponent {

  protected static CONTROL_BUTTON_ID_ADD = 'add';
  protected static CONTROL_BUTTON_ID_EDIT = 'edit';
  protected static CONTROL_BUTTON_ID_DELETE = 'delete';
  protected static CONTROL_BUTTON_ID_COPY_TO = 'copyTo';

  protected openViews = 0; // Number of openApplicationCacheDeleteDialog dialogs and etc.

  /**
   * Increases the openApplicationCacheDeleteDialog view amount by one.
   */
  protected increaseOpenView(): void {
    this.openViews++;
  }

  /**
   * Decreases the openApplicationCacheDeleteDialog view amount by one.
   */
  protected decreaseOpenView(): void {
    this.openViews--;
  }

  /**
   * Returns whether the openApplicationCacheDeleteDialog view number is zero. The return value of this tells if there are something opened
   * top of the entity array.
   * @return Is there at least one openApplicationCacheDeleteDialog view.
   */
  public isOpenViewsOpen(): boolean {
    return this.openViews > 0;
  }
}
